/**
 * @desc 通过账户安防公告查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.QueryAnnouncementNoticeRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AnnouncementNoticeResponse>>> {
  return defHttp.post({
    url: '/portal/announcement/select',
    data,
  });
}

export function mock(
  data: defs.QueryAnnouncementNoticeRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AnnouncementNoticeResponse>>> {
  return defHttp.post({
    url: '/mock/portal/announcement/select',
    data,
  });
}
